import React, { useState } from "react";
// import SearchPricelists from "./SearchPricelists";
import { Box, CircularProgress } from "@mui/material";
import { loaderBoxStyles, mainContainerStyles } from "./styles/styles";
import SupplierProfileModal from "../SupplierProfileModal";
import endpoints from "../../Helpers/Endpoints";
import { apiGetRequest } from "../../Helpers/Requests";
import ViewCommunityManagerButton from "./Content/ViewCommunityManagerButton";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../Helpers/formating";
import PricelistsContent from "./Content/PricelistsContent";
import FeesPricingButton from "./Content/FeesPricingButton";

const ManagePricelistsContainer = () => {
  const [showSupplierProfile, setShowSupplierProfile] = useState(false);
  const [supplierProfileData, setSupplierProfileData] = useState(null);
  const [loader, setLoader] = useState(false);

  const { t } = useTranslation([
    "page-manage-pricelists",
    "price-services-steps",
  ]);

  const getSupplierProfileData = async () => {
    try {
      setLoader(true);
      const response = await apiGetRequest(
        endpoints.getCommunitySupplierPricelistDetails
      );
      setSupplierProfileData(response?.data || {});
    } catch (err) {
      console.log("error: ", err);
    } finally {
      setLoader(false);
    }
  };

  const handleCommunityManagerClick = () => {
    getSupplierProfileData();
    setShowSupplierProfile(true);
  };

  const tableConfig = {
    columns: [
      {
        id: "variant",
        label: t("price-services-steps:table_columns.variant_sku"),
        render: (variant) => t(variant.sku, { ns: "sku" }),
      },
      {
        id: "unit",
        label: t("price-services-steps:table_columns.unit"),
        render: (variant) => t(variant.unit, { ns: "units" }),
      },
      {
        id: "basePrice",
        label: t("price-services-steps:table_columns.base_price"),
        render: (variant) => {
          const priceValue = formatPrice(variant.price);
          return priceValue ? `₪${priceValue}` : "-";
        },
      },
      {
        id: "market-price",
        label: t("price-services-steps:table_columns.typical_market_price"),
        render: (variant) => {
          const { market_price_range } = variant;
          if (market_price_range) {
            const min = formatPrice(market_price_range.min);
            const max = formatPrice(market_price_range.max);

            if (min != null && max != null) {
              return `₪${min} - ₪${max}`;
            } else if (min != null) {
              return `₪${min}`;
            } else if (max != null) {
              return `₪${max}`;
            }
          }
          return "";
        },
        headerStyle: {
          width: "20%",
        },
      },
    ],
  };

  const handleCloseSupplierProfileModal = () => {
    setShowSupplierProfile(false);
    setSupplierProfileData(null);
  };

  return (
    <Box sx={{ ...mainContainerStyles }}>
      <FeesPricingButton />
      <ViewCommunityManagerButton {...{ handleCommunityManagerClick }} />
      <PricelistsContent
        {...{ setPricelistsLoader: setLoader, handleCommunityManagerClick }}
      />
      {/* <SearchPricelists
        {...{ setPricelistsLoader: setLoader, handleCommunityManagerClick }}
      /> */}

      {showSupplierProfile && supplierProfileData && (
        <SupplierProfileModal
          {...{
            viewType: "viewAsCommunityManager",
            openSupplierProfileModal: showSupplierProfile,
            supplierProfileData,
            tableConfig,
            handleCloseSupplierProfileModal,
          }}
        />
      )}

      {loader && (
        <Box sx={loaderBoxStyles}>
          <CircularProgress
            size={80}
            sx={{
              color: "#248B70",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default ManagePricelistsContainer;
